import { ECardCategorySlug } from '@utils/storefront.util';

const categories: { [key in ECardCategorySlug]: string } = {
  bold: 'Bold',
  classic: 'Classic',
  cultural: 'Cultural',
  destination: 'Destination',
  'floral-and-botanical': 'Floral & Botanical',
  metallic: 'Metallic',
  modern: 'Modern',
  rustic: 'Rustic',
  seasonal: 'Seasonal',
  textured: 'Textured',
};
export const eCardsStorefrontPageContentData = {
  saveTheDates: 'Save the Dates',
  invitations: 'Invitations',
  linkToSaveTheDates: 'Looking for Save the Date Designs?',
  linkToInvitations: 'Looking for Invitation Designs?',
  eCardImageAltSuffix: {
    Invitation: 'Wedding Invitation',
    'Save the Date': 'Save the Date',
  },
  printNOnline: 'Print + Online',
  online: 'Online Only',
  categories,
  useThisTemplate: 'Use This Template',
  stdBannerEyebrow: 'Free Online Cards',
  stdBannerTitle: 'Save the Dates',
  stdBannerBody:
    'Design and send beautiful online save the date cards powered by the smarter guest list, with one-click add to calendar, so your guests can plan ahead for the big day!',
  invitationsBannerEyebrow: 'Free Online Invites + RSVPs',
  invitationsBannerTitle: 'Invitations',
  invitationsBannerBody:
    'Design and send beautiful, free, and unlimited online invitations. With multiple events and flexible RSVP questions powered by the smartest guest list on earth, these are invites worthy of your celebration.',
  notFindingWhatLooking: 'Not finding what you’re looking for?',
  letUsKnow: 'Let us know!',
  loadMoreButton: 'Load More Invitations',
} as const;
